<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';

html, body {
  height: 100%;
}

body {
  margin: 0;
}

.sr-only {
  clip-path: inset(50%);
  white-space: nowrap;
  clip: rect(0,0,0,0);
  position: absolute;
  overflow: hidden;
  height: 1px;
  padding: 0;
  width: 1px;
  border: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  background: url('./assets/archive.png') 0 / cover;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  height: 100%;
  color: #fff;

  &:before {
    background-image: linear-gradient(135deg, rgba(0,0,0,0.70) 0%, rgba(0,0,0,0.50) 50%);
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    content: '';
    left: 0;
    top: 0;
  }

  &:after {
    background-image: linear-gradient(135deg, rgba(26,103,249,0.00) 0%, rgba(26,103,249,0.50) 100%);
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    content: '';
    left: 0;
    top: 0;
  }

  .container {
    flex-direction: column;
    position: relative;
    max-width: 1200px;
    padding: 64px 1rem;
    margin: 0 auto;
    display: flex;
    width: 100%;
    z-index: 1;

    @media screen and (min-width: 992px) {
      padding: 64px 15px;
    }

    h1, h2, h3, h4, h5 {
      font-weight: 700;
    }

    h1 {
      margin-bottom: 2.75rem;
      font-size: 2.75rem;
    }
  }
}
</style>
